import React from "react";
import { toolRenderers } from "components/views/Synth2.0/ChatAgent/CommonChatComponent/ToolRenderer";
import type { SpaceMessage } from "types/spaceTypes";

interface SpaceToolRendererProps {
    message: SpaceMessage;
    expandedId?: string;
    setExpandedId?: (id: string) => void;
}


const SpaceToolRenderer: React.FC<SpaceToolRendererProps> = ({
    message,
    expandedId,
    setExpandedId
}) => {
    // Only render if this is an AI message with tool calls
    if (message.type !== 'ai' || !message.toolName || !message.resultMessage) {
        return null;
    }

    const { toolName, resultMessage, id: messageId } = message;
    
    // Get the appropriate renderer for this tool
    const Renderer = toolRenderers[toolName];
    
    if (!Renderer) {
        return null;
    }
    
    // Render the tool UI component with Space-specific container handling
    return (
        <div className="space-tool-renderer mb-2 relative z-10">
            {/* Simplified approach with proper content alignment */}
            <div 
                className="overflow-x-auto"
                style={{
                    width: '100%',
                    marginLeft: '-24px',
                    marginRight: '-32px',
                    paddingLeft: '24px',
                    paddingRight: '32px'
                }}
            >
                <Renderer
                    resultMessage={resultMessage}
                    expandedId={expandedId}
                    setExpandedId={setExpandedId}
                    messageId={messageId}
                    toolName={toolName}
                    // Pass any other props that specific renderers might need
                    threadId={messageId} // Use messageId as threadId for Space context
                />
            </div>
        </div>
    );
};

export default SpaceToolRenderer;
